<template>
  <v-card>
    <v-card-title v-if="canList" class="d-flex justify-space-between">
      <span>Filtros </span>
      <div>
        <v-btn
          class="mx-2"
          title="Configurar filtros"
          color="primary"
          @click="handleShowConfig"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
        <v-btn
          class="mx-2"
          title="Filtrar"
          color="secondary"
          @click="handleShowFilter"
        >
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-dialog v-model="showFilter" max-width="1200px">
      <faturamento-list-filtro-modal
        v-if="showFilter"
        @close="showFilter = false"
        @search="search"
        :isTransportadora="this.isTransportadora"
      />
    </v-dialog>
    <v-dialog v-model="showConfig" max-width="500px">
      <faturamento-list-filtro-config
        v-if="showConfig"
        @close="showConfig = false"
        :isTransportadora="this.isTransportadora"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

import FaturamentoListFiltroModal from './FaturamentoListFiltroModal/Componente.vue'
import FaturamentoListFiltroConfig from './FaturamentoListFiltroConfig/Componente.vue'
import { BasicPermissions, Sequences } from '@/utils/permissions'

export default {
  name: 'FaturamentoListFiltro',
  components: {
    FaturamentoListFiltroModal,
    FaturamentoListFiltroConfig,
  },
  props: {
    isTransportadora: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showFilter: false,
      showConfig: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions('patio', ['getAllAgendamentosByParams']),

    handleShowFilter() {
      this.showFilter = true
      this.showConfig = false
    },
    handleShowConfig() {
      this.showFilter = false
      this.showConfig = true
    },
    async search() {
      this.showFilter = false
      this.$emit('search')
    },
  },
  computed: {
    canList() {
      return this.$canDo(
        BasicPermissions.VISUALIZAR,
        Sequences.Faturamento.toString()
      )
    },
  },
}
</script>
